import { create } from 'zustand';

export type LayoutMode = 'rectangle' | 'square';

// The embed slide baseline (16:9 vs 1:1) is known per-page (e.g. ConnectPreview's
// template.layoutMode) but the EmbedScaler that zooms #ppt-stage lives globally in
// _app. This tiny store bridges the two so the scaler can pick the right baseline.
interface EmbedLayoutState {
  layoutMode: LayoutMode;
  setLayoutMode: (layoutMode: LayoutMode) => void;
}

export const useEmbedLayoutStore = create<EmbedLayoutState>()((set) => ({
  layoutMode: 'rectangle',
  setLayoutMode: (layoutMode) => set({ layoutMode }),
}));
